import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=f4edcdd8&"
import script from "./Basic.vue?vue&type=script&lang=ts&"
export * from "./Basic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports